<template>
  <div class="app-container">
    <div class="screen-search">
      <div class="approval-process">
        <el-card-title :title="title"/>
      </div>
      <el-search
        :form-item-data="formItemData"
        :rules="rules"
        :is-show.sync="isShow"
        :span="8"
        @onSubmitSingle="onSubmitSingle"
        @onSubmitMulti="onSubmitMulti">
        <el-button class="agent-btn" size="mini" type="primary" icon="icon-ccui-appoint" @click="handleAgent">维护采购组织
        </el-button>
      </el-search>
    </div>
    <div class="table-wapper">
      <div ref="treeDiv" class="tree-nav tree-container">
        <el-tree id="tree" ref="tree" :data="data" :default-expanded-keys="[1]" :props="defaultProps" :indent="0" class="tree" node-key="id" @node-click="handleNodeClick"/>
      </div>
      <div class="table-content">
        <div v-show="popoverShow" class="popover">
          <draggable :list="defaultFormThead" @change="handleTableChange">
            <el-checkbox-group v-for="(item,index) in defaultFormThead" v-model="item.checked" :key="index">
              <el-checkbox :label="item" :checked="item.checked" :width="item.width" :title="item.label" @change="handleUpdata(item, index)">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </draggable>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          :key="key"
          :fit="true"
          :row-style="rowClass"
          :cell-style="cellStyle"
          border
          style="width: 100%"
          class="detail"
          @row-click="jumpToDetail"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
          @header-dragend="tableTitleWidth"
          @header-click="handlePopoverShow"
        >
          <el-table-column type="selection" width="55"/>
          <el-table-column label="序号" width="50" prop="id"/>
          <el-table-column v-for="(table, index) in formTheadOptions" v-if="table.checked" :key="index" :label="table.label" :width="table.width" :prop="table.prop" :show-overflow-tooltip="true">
            <template slot-scope="scope">{{ scope.row[table.prop] }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" prop="operatingCode">
            <template slot-scope="scope">
              <el-button
                v-if="approvalBtn"
                size="mini"
                type="text"
                class="approval-btn"
              >审批
              </el-button>
              <el-button
                v-if="readBtn"
                size="mini"
                type="text"
                class="approval-btn"
              >查看
              </el-button>
              <div v-if="purchaseBtn">
                <el-button
                  :class="scope.row.operatingCode === true ? 'disabled' : ''"
                  :disabled ="scope.row.operatingCode === true ? true : false"
                  size="mini"
                  type="text"
                  @click="handleEdit(scope.$index, scope.row)"
                >开通</el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handlEpreview(scope.$index, scope.row)"
                >查看</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column :render-header="renderLastHeader" label="set" width="36"/>
        </el-table>
        <div class="table-footer">
          <div v-show="isSelection" class="operation">
            <el-button size="mini" class="btn-approval" type="default-bottom" @click="handleApproval">批量开通</el-button>
          </div>
          <div class="paging">
            <el-pagination
              :total="disposalNum"
              :current-page.sync="currentPage3"
              :page-size="5"
              prev-text="< 上一页"
              next-text="下一页 >"
              background
              layout="prev, pager, next, total, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"/>
            <el-button class="pagination-btn" size="medium" type="default-bottom" @click="handleSizeChange">确定</el-button>
          </div>
        </div>
      </div>
      <!--      <el-popover-->
      <!--        :offset="10"-->
      <!--        v-model="visible"-->
      <!--        placement="bottom-end"-->
      <!--        title="标题"-->
      <!--        width="140"-->
      <!--        trigger="click"-->
      <!--      >-->
      <!--        <draggable :list="defaultFormThead" @change="handleTableChange">-->
      <!--          <el-checkbox-group v-for="(item,index) in defaultFormThead" v-model="item.checked" :key="index">-->
      <!--            <el-checkbox :label="item" :checked="item.checked" :width="item.width" @change="handleUpdata(item, index)">{{ item.label }}</el-checkbox>-->
      <!--          </el-checkbox-group>-->
      <!--        </draggable>-->
      <!--        <div slot="reference" class="hidden-btn"/>-->
      <!--      </el-popover>-->
    </div>
  </div>
</template>

<script>

import draggable from 'vuedraggable'
// import { getList } from '@/api/purchasing-organization'
import {
  Popover,
  CheckboxGroup,
  Checkbox,
  Pagination,
  Button
} from 'ccui'
export default {
  components: {
    Popover,
    CheckboxGroup,
    Checkbox,
    Pagination,
    Button,
    draggable
  },
  data() {
    return {
      data: [{
        id: 1,
        label: '中国交建',
        children: [{
          label: '一航局',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '二航局',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '三航局',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '四航局',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '一公局',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '二公局',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '三公局',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '四公局',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '中交信科',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '中国港湾',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '中国港湾',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '中国路桥',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '中国疏浚',
          children: [{
            label: '三级 1-1-1'
          }]
        }, {
          label: '中国路建',
          children: [{
            label: '三级 1-1-1',
            children: [{
              label: '四级 1-1-1',
              children: [{
                label: '五级 1-1-1'
              }]
            }]
          }]
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      title: '采购组织',
      // 默认表格
      defaultFormThead: [
        { label: '4A组织编码', prop: 'creditCode', width: '100', checked: true },
        { label: '类型', prop: 'type', width: '50', checked: true },
        { label: '名称', prop: 'supplierName', width: 'auto', checked: true },
        { label: '简称', prop: 'abbreviation', width: '80', checked: true },
        { label: '上级单位', prop: 'superiorUnits', width: '100', checked: true },
        { label: '状态', prop: 'state', width: '80', checked: true }
      ],
      // 动态表格
      formTheadOptions: [],
      popoverShow: false,
      readBtn: false,
      approvalBtn: false,
      purchaseBtn: true,
      defaulTable: this.tableList.supplierList,
      dragging: false,
      tableDataContent: [],
      selectRow: [],
      selectData: [],
      code: [],
      isFocus: true,
      isSelection: false,
      disposalNum: 0,
      currentPage1: 1,
      currentPage2: 2,
      currentPage3: 3,
      currentPage4: 4,
      // 高级搜索组件数据
      formItemData: [
        {
          id: '1',
          type: 'input',
          placeHolder: '组织名称',
          // name: 'contractName',
          label: '组织名称：',
          value: '',
          outputValue: ''
        },
        {
          id: '2',
          type: 'select',
          placeHolder: '类型',
          name: 'contractNum',
          label: '类型：',
          value: '',
          outputValue: '',
          option: [
            {
              value: '1',
              label: '类型1A'
            }, {
              value: '2',
              label: '类型2B'
            }, {
              value: '3',
              label: '类型1C'
            }, {
              value: '4',
              label: '类型1D'
            }, {
              value: '5',
              label: '类型1E'
            }
          ]
        }, {
          id: '3',
          type: 'input',
          placeHolder: '所在省/地区',
          name: 'managingUnit',
          label: '所在省/地区：',
          value: '',
          outputValue: ''
        }, {
          id: '4',
          type: 'input',
          placeHolder: '申请类型',
          name: 'contractFirst',
          label: '申请类型：',
          value: '',
          outputValue: ''
        }, {
          id: '5',
          type: 'input',
          placeHolder: '审批状态',
          name: 'contractLast',
          label: '审批状态：',
          value: '',
          outputValue: ''
        }

      ],
      rules: {
        contractName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ]
      },
      value: '',
      k: 1,
      isShow: false,
      input: '',
      isIndeterminate: false,
      visible: false,
      checkAll: false,
      tableData: [],
      key: 1// table key
    }
  },
  watch: {
    // checkboxVal(valArr) {
    //   // console.log('valArr', valArr)
    //   this.formThead = this.formTheadOptions.filter(i => valArr.indexOf(i) >= 0)
    //   this.key = this.key + 1 // 为了保证table 每次都会重渲 In order to ensure the table will be re-rendered each time
    // },
    $route(to, from) {
      this.fetchDate()
      console.log('to from')
      console.log(to)
      console.log(from)
    },
    selectData(data) {
      this.selectRow = []
      if (data.length > 0) {
        data.forEach((item, index) => {
          this.selectRow.push(this.tableData.indexOf(item))
        })
      }
    }
  },
  created() {
    this.getList()
    this.setTableWidth()
    this.renderTable()
  },
  // 全局点击事件
  mounted: function() {
    this.globalClick(this.handlePopoverClose)
  },
  methods: {
    // 数据请求
    getList() {
      const contentHeight = document.body.clientHeight
      const tableHeight = contentHeight - 342
      const tableNumber = parseInt(tableHeight / 36)
      // 获取表格高度请求数据数量
      console.log('iiiii', contentHeight, tableHeight, tableNumber)
      getList({
        pageNo: 3,
        pageSize: tableNumber,
        isShowLoading: true
      }).then(res => {
        console.log('接收到的表格参数', res)
        this.tableData = res.data.data.list
        console.log(this.tableData)
        this.disposalNum = res.data.data.list.length
        // this.data = res.data.data.treeData
        for (let i = 0; i < this.disposalNum; i++) {
          this.tableDataContent = this.tableData[i]
        }
        // 判断操作按钮类型
        const key = res.data.data.list
        console.log('key', key)
        // for (let i = 0; i < key.length; i++) {
        //   this.operatingCode1 = key[i].operatingCode1
        //   this.operatingCode2 = key[i].operatingCode2
        //   console.log('key1', this.operatingCode1)
        //   console.log('key2', this.operatingCode2)
        // }
      })
    },
    // 树状导航
    handleNodeClick(data) {
      console.log(data)
      if (data.$treeNodeId !== 1) {
        this.getList()
      }
    },
    // 显示隐藏表格设置
    handlePopoverShow(column, event) {
      if (column.label === 'set' && this.popoverShow === false) {
        this.popoverShow = true
        console.log(this.popoverShow)
      } else if (column.label === 'set' && this.popoverShow === true) {
        this.popoverShow = false
        console.log(this.popoverShow)
      }
    },
    // 弹框关闭
    handlePopoverClose() {
      // if (this.popoverShow === true) {
      //   console.log(111)
      // }
    },
    // 表格渲染
    renderTable() {
      const localTableData = JSON.parse(localStorage.getItem(this.defaulTable))
      if (localTableData) {
        console.log('有本地表格数据')
        this.formTheadOptions = localTableData
        this.defaultFormThead = localTableData
      } else {
        console.log('无本地表格数据')
        // this.formTheadOptions = this.defaultFormThead
        const comment = JSON.stringify(this.defaultFormThead)
        localStorage.setItem(this.defaulTable, comment)
        const localTableData = JSON.parse(localStorage.getItem(this.defaulTable))
        this.formTheadOptions = localTableData
      }
    },
    // 表格拖动
    handleTableChange(val) {
      console.log('发生改变', val)
      const comment = JSON.stringify(this.defaultFormThead)
      localStorage.setItem(this.defaulTable, comment)
      const localTableData = JSON.parse(localStorage.getItem(this.defaulTable))
      this.formTheadOptions = localTableData
      // window.location.reload()
    },
    // 是否显示对应列
    handleUpdata(item, index) {
      console.log(44444, item.checked, index)
      for (let i = 0; i < this.defaultFormThead.length; i++) {
        if (i === index) {
          this.defaultFormThead.checked = !this.defaultFormThead.checked
        }
      }
      const comment = JSON.stringify(this.defaultFormThead)
      localStorage.setItem(this.defaulTable, comment)
      const localTableData = JSON.parse(localStorage.getItem(this.defaulTable))
      this.formTheadOptions = localTableData
    },
    // 渲染本地存储表格宽度
    setTableWidth() {
      const localTableData = JSON.parse(localStorage.getItem(this.defaulTable))
      if (localTableData) {
        for (let i = 0; i < this.formTheadOptions.length; i++) {
          if (this.formTheadOptions[i].label === localTableData[i].label) {
            this.formTheadOptions[i].width = localTableData[i].width
          }
        }
      } else {
        this.formTheadOptions = this.formTheadOptions
      }
    },
    // 表格宽度更改存入
    tableTitleWidth(newWidth, oldWidth, column, event) {
      for (let i = 0; i < this.defaultFormThead.length; i++) {
        if (this.defaultFormThead[i].label === column.label) {
          this.defaultFormThead[i].width = newWidth
        }
      }
      const comment = JSON.stringify(this.defaultFormThead)
      localStorage.setItem(this.defaulTable, comment)
      const localTableData = JSON.parse(localStorage.getItem(this.defaulTable))
      this.formTheadOptions = localTableData
    },
    // 根据返回状态显示不同的文字颜色
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 7 && row.state === '未开通') {
        return 'color:#D5090B;'
      } else if (columnIndex === 7 && row.state === '已开通') {
        return 'color:#00954C;'
      } else if (columnIndex === 7 && row.state === '拟开通') {
        return 'color:#FF954E;'
      }
    },
    // 表格筛选
    handleSelectionChange(data) {
      this.selectData = data
    },
    // 选中一行背景色更改
    rowClass({ row, rowIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { 'background-color': 'rgba(255,232,195,1) ' }
      }
    },
    // 表格按钮功能
    handleEdit(index, row) {
      console.log('单行开通', index, row.editCode)
      const edit = {
        // abbreviation: row.abbreviation,
        // applyType: row.applyType,
        // creditCode: row.creditCode,
        editCode: row.editCode = true,
        previewCode: row.previewCode = false,
        id: row.id
      }
      const editCode = JSON.stringify(edit)
      localStorage.setItem('code', editCode)
    },
    // 表格按钮功能
    handlEpreview(index, row) {
      console.log('查看id', index, row.previewCode)
      const edit = {
        // abbreviation: row.abbreviation,
        // applyType: row.applyType,
        // creditCode: row.creditCode,
        editCode: row.editCode = false,
        previewCode: row.previewCode = true,
        id: row.id
      }
      const previewCode = JSON.stringify(edit)
      localStorage.setItem('code', previewCode)
    },
    // 搜索右按钮
    handleAgent() {
      console.log('搜索右按钮')
    },
    handleApproval() {
      console.log('批量开通', this.code)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.getList()
    },
    onSubmitMulti(obj) {
      console.log('多字段查询')
      console.log(obj)
      this.getList()
    },
    onSubmitSingle(obj) {
      console.log('单字段查询')
      console.log(obj)
      this.getList()
    },
    // 点击表格对应列
    jumpToDetail(row, col, e) {
      console.log(row)
      console.log(col)
      console.log(e)
      if (row.id) {
        // this.$router.push('/organization/organization-manage/organization-list/batch-manage' + row.id)
        this.$router.push('/organization/organization-manage/organization-list/batch-manage')
      } else {
        this.$message('查看详情请点击有id的行')
      }
    },
    // 高级搜索展开按钮
    searchShow() {
      this.isShowVal = !this.isShowVal
      this.isShow = !this.isShow
    },
    onSubmit() {
      console.log(this.formInline)
      console.log(this.type.value)
      console.log(this.price.value)
      console.log(this.approval.value)
    },
    onClear() {
      for (var i in this.formInline) {
        this.formInline[i] = ''
        break
      }
      this.type.value = ''
      this.price.value = ''
      this.approval.value = ''
    },
    // handleDisposal() {
    //   this.isFocus = true
    //   this.readBtn = false
    //   this.approvalBtn = true
    //   this.getList()
    // },
    // handleProcessed() {
    //   this.isFocus = false
    //   this.readBtn = true
    //   this.approvalBtn = false
    //   this.getList()
    // },
    fetchDate() {
      console.log('路由发生变化了')
    },
    handleCheckAllChange(val) {
      this.isIndeterminate = false
      const arr = []
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id)
      }
      this.code = arr
      if (val.length) {
        this.isSelection = true
      } else {
        this.isSelection = false
      }
      if (typeof val === 'boolean') {
        if (val) {
          console.log('xxxxxx', this.toggleSelection)
          this.toggleSelection(this.tableData)
        } else {
          this.toggleSelection([])
        }
      } else {
        this.checkAll = val.length !== 0
      }
    },
    handleCheckChange(val) {
      console.log('handleCheckChange')
      console.log('fffffff', val)
      const arr = []
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id)
      }
      this.code = arr
      if (val.length) {
        this.isSelection = true
      } else {
        this.isSelection = false
      }
      if (val.length > 0 && val.length < 2) {
        this.isIndeterminate = true
      } else if (val.length === 2) {
        this.checkAll = true
        this.isIndeterminate = false
      } else {
        this.checkAll = false
        this.isIndeterminate = false
      }
    },
    toggleSelection(rows) {
      console.log('ttttttt', this.$refs.multipleTable)
      this.$refs.multipleTable.clearSelection()
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      }
    },
    renderLastHeader(h, { column, $index }) {
      column.minWidth = 55
      column.realWidth = 55
      return h('span', {}, [
        h('svg-icon', {
          props: {
            iconClass: 'setup'
          },
          on: {
            click: () => {
              this.showControlPanel()
            }
          },
          slot: 'reference'
        })
      ])
    },
    showControlPanel() {
      this.visible = !this.visible
    },
    sizeChangeHandler(e) {
    },
    pageChangeHandler(e) {
    }
  }
}
</script>

<!--<style lang="scss" scoped>-->
<!--  @import "~@/styles/variables";-->
<!--  .app-main {-->
<!--    .el-tabel {-->
<!--      margin-bottom: 70px;-->
<!--    }-->

<!--    .app-container {-->
<!--      padding: 0 20px 20px;-->
<!--      background: $&#45;&#45;color-white;-->

<!--      .screen-search {-->
<!--        .approval-process {-->
<!--          position: relative;-->
<!--          top: 13px;-->
<!--          width: 200px;-->
<!--          z-index: 10;-->
<!--          .el-card-title{-->
<!--            margin: 0;-->
<!--          }-->
<!--          .processed {-->
<!--            margin-left: 25px;-->
<!--          }-->

<!--          .active {-->
<!--            color: $&#45;&#45;cardtitle-color-text;-->
<!--            border-bottom: 2px solid $&#45;&#45;cardtitle-color-hover;-->
<!--            border-radius: 0;-->
<!--            font-weight: 600;-->
<!--            font-size: 14px;-->
<!--          }-->
<!--        }-->

<!--        .el-search {-->
<!--          position: relative;-->
<!--          bottom: 18px;-->

<!--          /deep/ .el-search-bar {-->
<!--            .el-select{-->
<!--              max-width: 102px;-->
<!--            }-->
<!--            .searcher{-->
<!--              width: 150px;-->
<!--              /deep/ .el-input__inner{-->
<!--                padding: 0;-->
<!--                margin-left: 6px;-->
<!--              }-->
<!--            }-->
<!--          }-->

<!--          .agent-btn {-->
<!--            width: 115px;-->
<!--            height: 30px;-->
<!--            border-radius: 2px;-->
<!--            color: $&#45;&#45;color-white;-->
<!--            font-size:14px;-->
<!--            font-weight:400;-->
<!--            /deep/ .icon-ccui-appoint{-->
<!--              margin-right:3px ;-->
<!--            }-->
<!--          }-->
<!--        }-->
<!--      }-->

<!--      .table-wapper {-->
<!--        background:$&#45;&#45;color-white;-->
<!--        position: relative;-->
<!--        /*树状虚线*/-->
<!--        .tree-container /deep/ .el-tree > .el-tree-node:after {-->
<!--          border-top: none;-->
<!--        }-->
<!--        .tree /deep/ .el-tree-node {-->
<!--          position: relative;-->
<!--          padding-left: 16px;-->
<!--        }-->

<!--        .tree /deep/ .el-tree-node__children {-->
<!--          padding-left: 16px;-->
<!--        }-->

<!--        .tree /deep/ .el-tree-node :last-child:before {-->
<!--          height: 38px;-->
<!--        }-->

<!--        .tree /deep/ .el-tree > .el-tree-node:before {-->
<!--          border-left: none;-->
<!--        }-->

<!--        .tree-container /deep/ .el-tree > .el-tree-node:after {-->
<!--          border-top: none;-->
<!--        }-->

<!--        .tree /deep/ .el-tree-node:before {-->
<!--          content: "";-->
<!--          left: -4px;-->
<!--          position: absolute;-->
<!--          right: auto;-->
<!--          border-width: 1px;-->
<!--        }-->

<!--        .tree /deep/ .el-tree-node:after {-->
<!--          content: "";-->
<!--          left: -4px;-->
<!--          position: absolute;-->
<!--          right: auto;-->
<!--          border-width: 1px;-->
<!--        }-->

<!--        .tree /deep/ .el-tree-node:before {-->
<!--          border-left: 1px solid $&#45;&#45;color-assist-background;-->
<!--          bottom: 0px;-->
<!--          height: 100%;-->
<!--          top: -26px;-->
<!--          width: 1px;-->
<!--        }-->

<!--        .tree /deep/ .el-tree-node:after {-->
<!--          border-top: 1px solid $&#45;&#45;color-assist-background;-->
<!--          height: 20px;-->
<!--          top: 12px;-->
<!--          width: 24px;-->
<!--        }-->

<!--        .tree-container { //树的parent，样式自定-->
<!--        }-->
<!--        .tree-nav{-->
<!--          position: absolute;-->
<!--          float: left;-->
<!--          width: 160px;-->
<!--          height: 100%;-->
<!--          border:1px solid $&#45;&#45;color-assist-background;-->
<!--          overflow:scroll;  /* x y都出现滚动条 */-->
<!--          .el-tree{-->
<!--            display: inline-block;-->
<!--            margin: 20px 0;-->
<!--            /deep/ .el-tree-node{-->
<!--              /deep/ .el-tree-node__content{-->
<!--                /deep/ .el-tree-node__label{-->
<!--                  font-size: 13px;-->
<!--                  font-weight: 600;-->
<!--                  color: $&#45;&#45;table-row-color;-->
<!--                }-->
<!--              }-->
<!--              /deep/ .el-tree-node__children{-->
<!--                /deep/ .el-tree-node__label{-->
<!--                  font-size: 13px;-->
<!--                  font-weight: 400;-->
<!--                  color: $&#45;&#45;color-text-regular;-->
<!--                }-->
<!--              }-->
<!--            }-->
<!--          }-->
<!--        }-->
<!--        .table-content{-->
<!--          margin-left: 180px;-->
<!--          .el-table{-->
<!--            .el-table_1_column_9{-->
<!--              button:nth-child(2){-->
<!--                border-left: 1px $&#45;&#45;table-border-left solid;-->
<!--                padding: 0 0 0 3px;-->
<!--                margin: 0;-->
<!--              }-->
<!--              .disabled{-->
<!--                /deep/ span{-->
<!--                  color: $&#45;&#45;table-border-left;-->
<!--                }-->
<!--              }-->
<!--            }-->
<!--          }-->
<!--          .popover{-->
<!--            width: 140px;-->
<!--            background: $&#45;&#45;color-white;-->
<!--            position: absolute;-->
<!--            z-index: 1000;-->
<!--            right: 5px;-->
<!--            top: 35px;-->
<!--            padding: 10px 0;-->
<!--            box-shadow:0px 2px 8px 0px $&#45;&#45;popover-color;-->
<!--            .el-checkbox-group{-->
<!--              padding: 2px 0 2px 10px;-->
<!--              width: 140px;-->
<!--              font-weight: 400 !important;-->
<!--              .el-checkbox{-->
<!--                /deep/ .el-checkbox__label{-->
<!--                  width: 88px;-->
<!--                  height: 15px;-->
<!--                  /*background: red;*/-->
<!--                  overflow: hidden;-->
<!--                  text-overflow:ellipsis;-->
<!--                  white-space: nowrap;-->
<!--                }-->
<!--              }-->
<!--            }-->
<!--            .el-checkbox-group:hover{-->
<!--              background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHdpZHRoPSIxMXB4IiBoZWlndGg9IjExcHgiIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMTEgMTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDExIDEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO2ZpbGw6IzMzMzMzMzt9Cjwvc3R5bGU+Cjx0aXRsZT7lkIjlubblvaLnirY8L3RpdGxlPgo8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KPGcgaWQ9Iui/kOiQpeS8muWRmOS4reW/gyI+Cgk8ZyBpZD0i5Lqk5piTLei0puWNlS3mk43kvZwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjA3LjAwMDAwMCwgLTQyMy4wMDAwMDApIj4KCQk8ZyBpZD0i5YiG57uELTgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyMDcuMDAwMDAwLCA0MjMuMDAwMDAwKSI+CgkJCTxnIGlkPSLliIbnu4QtOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIC0wLjAwMDAwMCkiPgoJCQkJPHBhdGggaWQ9IuWQiOW5tuW9oueKtiIgY2xhc3M9InN0MCIgZD0iTTIsNS41aDN2LTNMNC40LDMuM0M0LjIsMy41LDMuOSwzLjYsMy43LDMuNFMzLjQsMi45LDMuNiwyLjdsMS41LTIKCQkJCQljMC4yLTAuMywwLjYtMC4zLDAuOCwwbDEuNSwyYzAuMiwwLjIsMC4xLDAuNS0wLjEsMC43UzYuOCwzLjUsNi42LDMuM0w2LDIuNXYzaDNMOC4yLDQuOUM4LDQuNyw3LjksNC40LDguMSw0LjIKCQkJCQlDOC4zLDQsOC42LDMuOSw4LjgsNC4xbDIsMS41YzAuMywwLjIsMC4zLDAuNiwwLDAuOGwtMiwxLjVDOC42LDguMSw4LjMsOCw4LjEsNy44QzcuOSw3LjYsOCw3LjMsOC4yLDcuMUw5LDYuNUg2djNsMC42LTAuOAoJCQkJCWMwLjItMC4yLDAuNS0wLjMsMC43LTAuMWMwLjIsMC4yLDAuMywwLjUsMC4xLDAuN2wtMS41LDJjLTAuMiwwLjMtMC42LDAuMy0wLjgsMGwtMS41LTJDMy40LDkuMSwzLjUsOC44LDMuNyw4LjYKCQkJCQljMC4yLTAuMiwwLjUtMC4xLDAuNywwLjFMNSw5LjV2LTNIMmwwLjgsMC42QzMsNy4zLDMuMSw3LjYsMi45LDcuOEMyLjcsOCwyLjQsOC4xLDIuMiw3LjlsLTItMS41Yy0wLjMtMC4yLTAuMy0wLjYsMC0wLjhsMi0xLjUKCQkJCQlDMi40LDMuOSwyLjcsNCwyLjksNC4yQzMuMSw0LjQsMyw0LjcsMi44LDQuOUwyLDUuNXoiIGZpbGw9IiNjM2MzYzMiLz4KCQkJPC9nPgoJCTwvZz4KCTwvZz4KPC9nPgo8L3N2Zz4K') $&#45;&#45;popover-hover-color no-repeat right;-->
<!--              background-position-x: 120px;-->
<!--            }-->
<!--          }-->
<!--          /deep/ .table-footer {-->
<!--            height: 30px;-->
<!--            line-height: 30px;-->
<!--            background-color: $&#45;&#45;color-white;-->
<!--            z-index: 5;-->
<!--            width: 100%;-->
<!--            margin-top: 20px;-->

<!--            .operation {-->
<!--              float: left;-->
<!--              .btn-approval{-->
<!--                width:68px;-->
<!--                height:30px;-->
<!--                font-size:13px;-->
<!--                font-weight:400;-->
<!--                color:$&#45;&#45;color-text-regular;-->
<!--                padding:8px 0;-->
<!--              }-->
<!--              .btn-export {-->
<!--                width: 56px;-->
<!--                height: 30px;-->
<!--                font-size:13px;-->
<!--                font-weight:400;-->
<!--                color:$&#45;&#45;color-text-regular;-->
<!--                margin-left: 5px;-->
<!--                padding:8px 0;-->
<!--              }-->

<!--              button {-->
<!--                background: $&#45;&#45;button-background-color;-->
<!--                border: 1px solid $&#45;&#45;button-border-color;-->
<!--                width: 68px;-->

<!--                .icon-ccui-down {-->
<!--                  font-size: 8px;-->
<!--                  display: inline-block;-->
<!--                  transform: rotate(60deg);-->
<!--                }-->
<!--              }-->
<!--            }-->

<!--            .paging {-->
<!--              float: right;-->
<!--              /*padding-top: 20px;*/-->
<!--              padding-right: 20px;-->
<!--              height: 30px;-->
<!--              display: flex;-->
<!--              .el-pagination {-->
<!--                color: $&#45;&#45;pagination-border-color;-->
<!--                font-weight: 400;-->
<!--                :disabled{-->
<!--                  color:$&#45;&#45;pagination-color;-->
<!--                }-->
<!--                buttveon {-->
<!--                  margin-right: 3px;-->
<!--                  font-size: 14px;-->
<!--                }-->

<!--                .el-pager {-->
<!--                  font-size: 14px;-->

<!--                  .number {-->
<!--                    font-size: 14px;-->
<!--                    width: 30px;-->
<!--                    height: 30px;-->
<!--                    color: $&#45;&#45;pagination-border-color;-->
<!--                    background: $&#45;&#45;pagination-btn-background-color;-->
<!--                    border: 1px solid $&#45;&#45;pagination-btn-border-color;-->
<!--                    margin: 0;-->
<!--                    margin-right: 3px;-->
<!--                    border-radius: 0;-->
<!--                  }-->

<!--                  .more {-->
<!--                    font-size: 14px;-->
<!--                    width: 30px;-->
<!--                    height: 30px;-->
<!--                    color: $&#45;&#45;pagination-border-color;-->
<!--                    background: $&#45;&#45;more-background-color;-->
<!--                    margin: 0;-->
<!--                    margin-right: 3px;-->
<!--                    border-radius: 0;-->
<!--                  }-->

<!--                  .active {-->
<!--                    width: 30px;-->
<!--                    height: 30px;-->
<!--                    background-color: $&#45;&#45;color-white !important;-->
<!--                    color: $&#45;&#45;cardtitle-color-hover !important;-->
<!--                    border: none;-->
<!--                  }-->
<!--                }-->
<!--              }-->

<!--              .pagination-btn {-->
<!--                width: 42px !important;-->
<!--                height: 30px !important;-->
<!--                background: $&#45;&#45;pagination-btn-background-color !important;-->
<!--                border: 1px solid $&#45;&#45;pagination-btn-border-color !important;-->
<!--                border-radius: 0;-->
<!--                padding: 6px 0 0 0 !important;-->
<!--                font-size:14px;-->
<!--                font-weight:400;-->
<!--                color:$&#45;&#45;pagination-border-color;-->
<!--              }-->

<!--              /*justify-content: space-between;*/-->
<!--              .el-button {-->
<!--                width: 65px;-->
<!--                height: 30px;-->
<!--                background: $&#45;&#45;pagination-btn-background-color;-->
<!--                border: 1px solid $&#45;&#45;pagination-btn-border-color;-->
<!--                display: block;-->
<!--              }-->
<!--              .btn-prev {-->
<!--                border-radius: 0;-->
<!--                width: 72px;-->
<!--                height: 30px;-->
<!--                background: $&#45;&#45;pagination-btn-background-color;-->
<!--                border: 1px solid $&#45;&#45;pagination-btn-border-color;-->
<!--                font-size: 14px;-->
<!--                color: $&#45;&#45;pagination-border-color;-->

<!--                span {-->
<!--                  font-size: 14px;-->
<!--                }-->
<!--              }-->

<!--              .btn-next {-->
<!--                border-radius: 0;-->
<!--                width: 72px;-->
<!--                height: 30px;-->
<!--                background: $&#45;&#45;pagination-btn-background-color;-->
<!--                border: 1px solid $&#45;&#45;pagination-btn-border-color;-->
<!--                margin: 0;-->
<!--                font-size: 14px;-->
<!--                color: $&#45;&#45;pagination-border-color;-->

<!--                span {-->
<!--                  font-size: 14px;-->
<!--                }-->
<!--              }-->

<!--              .el-pagination__total {-->
<!--                font-size: 12px;-->
<!--                color: $&#45;&#45;pagination-border-color;-->
<!--                font-weight: 400;-->
<!--                margin: 1px 0 0 8px;-->
<!--              }-->

<!--              .el-pagination__jump {-->
<!--                font-size: 12px;-->
<!--                color: $&#45;&#45;pagination-border-color;-->
<!--                font-weight: 400;-->
<!--                margin-left: 5px;-->

<!--                .el-pagination__editor {-->
<!--                  width: 35px;-->

<!--                  .el-input__inner {-->
<!--                    border-radius: 0;-->
<!--                  }-->
<!--                }-->
<!--              }-->
<!--            }-->
<!--          }-->
<!--        }-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--</style>-->

